import classNames from 'classnames';
import { DropdownWrapper, HeightLimitedDropdownMenu, SpDropdownItem } from 'components/shared/Dropdown';
import { FC } from 'react';
import { DropdownToggle } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import type { PlatformFilter } from 'state/blotters/common/blotter.model';

export interface PlatformFilterProps {
  className?: string;
  platformFilter: PlatformFilter;
  fetchingPlatformsStatus: 'loading' | 'error' | 'success' | null;
  platforms: readonly string[] | null;
  onPlatformFilterChanged: (platform: PlatformFilter) => void;
}

export const PlatformFilterSelector: FC<PlatformFilterProps> = ({
  className,
  platformFilter,
  onPlatformFilterChanged,
  fetchingPlatformsStatus: status,
  platforms: data,
}) => {
  if (status === 'loading') {
    return <div className={classNames('form-select form-select-md', className)}>{<Skeleton width="13em" />}</div>;
  }

  const isDisabled = status !== 'success';

  return (
    <DropdownWrapper className="btn-group border-start border-opacity-40" openOnHover disabled={isDisabled}>
      <DropdownToggle
        aria-haspopup="listbox"
        variant="link"
        data-e2e="platform-filter"
        className="btn btn-flat-secondary btn-lg btn-icon-start dropdown-toggle pe-2"
        disabled={isDisabled}
      >
        <i className="icon">layers</i>
        <span className="d-none d-lg-inline">
          {platformFilter === 'allPlatforms' ? (
            <FormattedMessage id="blotter.filter.platforms.allPlatforms" />
          ) : (
            platformFilter
          )}
        </span>
      </DropdownToggle>
      <HeightLimitedDropdownMenu role="listbox">
        <SpDropdownItem
          active={platformFilter === 'allPlatforms'}
          onClick={() => onPlatformFilterChanged('allPlatforms')}
        >
          <FormattedMessage id="blotter.filter.platforms.allPlatforms" />
        </SpDropdownItem>
        {data?.map(platform => (
          <SpDropdownItem
            active={platform === platformFilter}
            key={platform}
            onClick={() => onPlatformFilterChanged(platform)}
          >
            {platform}
          </SpDropdownItem>
        ))}
      </HeightLimitedDropdownMenu>
    </DropdownWrapper>
  );
};
